module.exports = __webpack_public_path__ + "static/img/mystery-box3.fa034de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-template/mystery-box3.png
// module id = VNiC
// module chunks = 215